import { NAV_TOP_ACTIONS, NAV_BOTTOM_ACTIONS } from "../editors.consts";

alert(JSON.stringify(process.env.NODE_ENV));

export default {

  data: () => {
    return {
      topNavActions: NAV_TOP_ACTIONS,
      bottomNavActions: NAV_BOTTOM_ACTIONS
    };
  },

  methods: {
    callback(action) {
      //should be handled inside either here or on top
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/editors/nav/nav.js